export default "__VITE_PUBLIC_ASSET__ae60e2a2__"